<template>
  <div class="book-reading-nav">
    <div class="book-reading-nav__container">
      <router-link
        :to="backLink.previousPage.fullPath"
        class="article-single__publisher-link book-reading-nav__prev-box"
      >
        <div class="book-reading-nav__link">
          <span class="book-reading-nav__ihon iconfont iprev"></span>
          {{ backLink.previousPageLabel }}
        </div>
      </router-link>
    </div>

    <div class="book-reading-nav__container">
      <router-link
        v-if="article.nextLink"
        :to="article.nextLink.route"
        class="article-single__next-link book-reading-nav__next-box"
      >
        <div class="book-reading-nav__link book-reading-nav__next">
          Next Article<span
            class="book-reading-nav__icon iconfont inext"
          ></span>
        </div>
        <p class="book-reading-nav__name book-reading-nav__next-name">
          {{ article.nextLink.title }}
        </p>
      </router-link>
      <router-link
        v-else
        :to="{ name: 'articles' }"
        class="article-single__next-link book-reading-nav__next-box"
      >
        <div class="book-reading-nav__link book-reading-nav__next">
          Back to Articles<span
            class="book-reading-nav__icon iconfont inext"
          ></span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { backLink } from '@/models/backlink'
import type { ArticleView } from '@/models/doc.article'

defineProps<{
  article: ArticleView
}>()
</script>
